/**
 * Do the default transition logic.
 *
 * @param  {JSON} response
 * @param  {ctx} ctx
 * @return {void}
 */
export default (response, ctx) => {
    const page = document.getElementById('page');

    for (let i = 0; i < page.children.length; i++) {
        const child = page.children[i];

        child.classList.add('current-page-content');
    }

    page.classList.add('start-transition');
    page.insertAdjacentHTML('beforeend', response.data);

    // Pass the component definition to the resolve callback
    EventBus.$once('page-transition-mounted', () => {
        const onComplete = () => {
            // Re-enable
            TweenMax.set('.story-page', { clearProps: 'all' });
            TweenMax.set('.story-page-holder', { clearProps: 'all' });
            TweenMax.set('.story-page .top-layer', { autoAlpha: 1 });
            TweenMax.set('.story-page .story-image', { autoAlpha: 1 });
            document.querySelector('.story-page .story-content').style.background = '';
            TweenMax.set(['.modules-container'], { clearProps: 'all' });

            // Enter image
            TweenMax.to('.story-image .overlay-animation', window.transitionVars.imageEnterDuration, { scaleX: '0', ease: Expo.easeOut }, window.transitionVars.imageEnter);

            document.getElementById('page').classList.remove('start-transition');
            window.scrollTo(0, 0);
            App.router.pageTransitionComplete();
            App.darkHeader = true;
        };

        // Disable
        TweenMax.set('.story-page .top-layer', { autoAlpha: 0 });
        TweenMax.set('.story-page .story-image', { autoAlpha: 0 });
        document.querySelector('.story-page .story-content').style.background = 'none';

        // TweenMax.set('.page.overview', { position: 'absolute', top: 0, width: '100%' });
        TweenMax.set('.story-page-holder', { position: 'fixed', top: 0, width: '100%' });

        // Scale curtain and enter without image
        TweenMax.set('.story-page', { autoAlpha: 1, backgroundColor: 'transparent' });
        this.enterStoryTl = new TimelineMax({
            paused: true, immediateRender: true, onComplete,
        });

        this.enterStoryTl.timeScale(1);

        this.enterStoryTl.to('.slide .subline .movement-container', 0.8, { y: '100%' }, 0);
        this.enterStoryTl.to('.slide .scroll .movement-container', 0.8, { y: '-100%' }, 0);
        this.enterStoryTl.to('.slide h1 .movement-container', 0.8, { y: '100%' }, 0);
        this.enterStoryTl.to(['.slider-control .circle'], 0.8, { scale: 0, transformOrigin: 'center center' }, 0);
        this.enterStoryTl.to(['.slider-control.next .arrow'], 0.8, { autoAlpha: 0, y: '-100%' }, 0);
        this.enterStoryTl.to(['.slider-control.previous .arrow'], 0.8, { autoAlpha: 0, y: '100%' }, 0);

        this.enterStoryTl.to('.story-page .transition-curtain', 1, { scaleY: 1, ease: CustomEase.create('custom', 'M0,0 C0.25,0.1 0.25,1 1,1') }, 0.2);
        this.enterStoryTl.fromTo('.story-page .title-holder .line', 0.6, { scaleY: '0', ease: Power2.easeOut }, { scaleY: '1', ease: Power2.easeOut }, 0.8);
        this.enterStoryTl.fromTo('.story-page .title-holder .subline .movement-container', 0.8, { y: '120%' }, { y: '0%', ease: Power3.ease }, 0.8);
        this.enterStoryTl.staggerFromTo('.story-page .title-holder h1 .movement-container', 0.8, { y: '110%' }, { y: '0%', ease: Power3.easeOut }, 0.1, 0.8);
        this.enterStoryTl.fromTo('.story-page .reading-time .movement-container', 0.8, { y: '120%', ease: Power3.ease }, { y: '0%', ease: Power3.ease }, 0.8);
        this.enterStoryTl.fromTo('.story-page .modules-container', 0.8, { y: '50px', autoAlpha: '0', ease: Power3.ease }, { y: '0', autoAlpha: '1', ease: Power3.ease }, 0.8);
        this.enterStoryTl.staggerFromTo('.story-page .social-icon', 0.3, { autoAlpha: '0', scale: '0' }, {
            delay: '-0.1',
            autoAlpha: '1',
            scale: '1.1',
            onCompleteParams: ['{self}'],
            onComplete(tween) {
                TweenMax.to(tween.target, 0.2, { scale: '1' });
            },
        }, 0.1, 0.8);

        this.enterStoryTl.play();
    });

    App.router.buildPage('#page');
};



// WEBPACK FOOTER //
// ./resources/assets/js/navigation/transitions/overview-to-story.js